define('directives/mysetting/identityInfo.directives',['app'], function (app) {
    app.directive('identityInfoDirective', ['$state', 'projectManageService','modBussService', 'auiUpload',
        function ($state, projectManageService,modBussService, auiUpload) {
            return {
                restrict: 'E',
                replace: true,
                require: "?ngModel",
                templateUrl: 'directives/mysetting/identityInfo.html',
                link: function ($scope, $element, attrs, ngModelCtrl) {
                    var Model = $scope.Model;
                    $scope.photoUrl =  sysParamCfg.photoUrl
                    Model.identityInfoFlag = false
                    if(Model.userInfo.userType === 2) {
                        Model['contactorImg10WH'] = ''
                        Model['corpEntityPicFileWH'] = ''
                        Model['corpEntityPicFile1WH'] = ''
                        Model['corpEntityPicFile'] = ''
                        Model['corpEntityPicFile1'] = ''
                        Model['contactorImg10'] = ''
                    }else {
                        Model['idCardPicFgWH'] = ''
                        Model['idCardPicBgWH'] = ''
                        Model['perCtfFg'] = ''
                        Model['perCtfBg'] = ''
                    }

                    if(Model.developerAttachment) {
                        if(Model.developerAttachment.attachment10 || Model.myUserInfo.contactorImg10) {
                            Model['contactorImg10'] = Model.developerAttachment.attachment10 ? Model.developerAttachment.attachment10: Model.myUserInfo.contactorImg10;
                            setDrawImage('contactorImg10','contactorImg10WH')
                        }
                        if(Model.developerAttachment.attachment4) {
                            Model['corpEntityPicFile'] = Model.developerAttachment.attachment4
                            setDrawImage('corpEntityPicFile','corpEntityPicFileWH')
                        }
                        if(Model.developerAttachment.attachment5) {
                            Model['corpEntityPicFile1'] = Model.developerAttachment.attachment5
                            setDrawImage('corpEntityPicFile1','corpEntityPicFile1WH')
                        }
                        if(Model.developerAttachment.attachment1) {
                            Model['perCtfFg'] = Model.developerAttachment.attachment1
                            setDrawImage('perCtfFg','idCardPicFgWH')
                        }
                        if(Model.developerAttachment.attachment2) {
                            Model['perCtfBg'] = Model.developerAttachment.attachment2
                            setDrawImage('perCtfBg','idCardPicBgWH')
                        }
                    }

                    function setDrawImage(type, typewh) {
                        AUI.HTMLUtil.drawImage(180, 120, Model[type], function (wh) {
                            $scope.$apply(function () {
                                Model[typewh] = wh;
                            });
                        });
                    }

                    function upload2openUP(files, options, img, imgWH) {
                        auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                            if (fileUrl) {
                                var changed = fileUrl && fileUrl != Model[img];
                                if(changed) {
                                    Model[img] = fileUrl;
                                    $scope.greenSubmit()
                                    $scope.isBankCNChanged = true
                                    Model.identityInfoFlag = true
                                }
                                AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                                    $scope.$apply(function () {
                                        Model[imgWH] = wh;
                                    });
                                });
                            }
                        });
                    }

                    Model.uploadCorpEntityPicFile1 = function (files, options) {
                        upload2openUP(files, options, 'corpEntityPicFile1', 'corpEntityPicFile1WH');
                    };

                    Model.uploadCorpEntityPicFile = function (files, options) {
                        upload2openUP(files, options, 'corpEntityPicFile', 'corpEntityPicFileWH');
                    };

                    Model.uploadContactorImg10 = function (files, options) {
                        upload2openUP(files, options, 'contactorImg10', 'contactorImg10WH');
                    };

                    Model.uploadPerCtfBg = function (files, options) {
                        upload2openUP(files, options, 'perCtfFg', 'idCardPicFgWH');
                    };

                    Model.uploadPerCtfBgImg = function (files, options) {
                        upload2openUP(files, options, 'perCtfBg', 'idCardPicBgWH');
                    };

                }
            }
        }])
});
